module.exports = __webpack_public_path__ + "7342242b0e0a5befcc18e32af7cda292.MP3";